import { get } from 'lodash';
import { MODAL_TYPE_POST_SETTINGS } from '@wix/communities-blog-client-common';
import { getModal } from '../modals/framework/store/modal-selectors';
import { type AppState } from '../types';

export const getPostSettingsModalProps = (state: AppState) =>
  get(getModal(state, MODAL_TYPE_POST_SETTINGS), 'props', {});
